(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    if (!window.__productDescriptionTextOnlyInit) {
    window.__productDescriptionTextOnlyInit = true;

    const cleanProductDescriptionHtml = (html) => {
      const parser = new DOMParser();
      const documentFragment = parser.parseFromString(html, 'text/html');

      documentFragment.querySelectorAll('img, picture, video, iframe, model-viewer, script, style').forEach((node) => {
        node.remove();
      });

      documentFragment.querySelectorAll('*').forEach((node) => {
        if (node.tagName === 'P' && !node.textContent.trim()) {
          node.remove();
        }
      });

      return documentFragment.body.innerHTML.trim();
    };

    const hydrateProductDescriptionBlock = async (block) => {
      if (block.dataset.productDescriptionHydrated === 'true') return;

      const endpoint = block.dataset.productDescriptionEndpoint;
      const content = block.querySelector('.text-block');

      if (!endpoint || !content) return;

      try {
        const response = await fetch(endpoint, {
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) return;

        const productData = await response.json();
        const cleanedHtml = cleanProductDescriptionHtml(productData.description || '');

        if (!cleanedHtml) return;

        content.innerHTML = cleanedHtml;
        block.dataset.productDescriptionHydrated = 'true';
      } catch (error) {
        console.warn('Product description refresh failed', error);
      }
    };

    const initProductDescriptionBlocks = () => {
      document.querySelectorAll('[data-product-description-block]').forEach((block) => {
        hydrateProductDescriptionBlock(block);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductDescriptionBlocks, { once: true });
    } else {
      initProductDescriptionBlocks();
    }

    document.addEventListener('shopify:section:load', initProductDescriptionBlocks);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ravella-product-trust-stack"] && !Shopify.designMode) return;
  try {
    (function() {
    const countdowns = document.querySelectorAll('[data-rav-local-midnight-countdown]');
    if (!countdowns.length) return;

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function getTonightEnd() {
      const end = new Date();
      end.setHours(23, 59, 59, 999);
      return end.getTime();
    }

    for (const countdown of countdowns) {
      const hoursEl = countdown.querySelector('[data-hours]');
      const minutesEl = countdown.querySelector('[data-minutes]');
      const secondsEl = countdown.querySelector('[data-seconds]');
      if (!hoursEl || !minutesEl || !secondsEl) continue;

      function updateCountdown() {
        const distance = Math.max(getTonightEnd() - Date.now(), 0);
        const hours = Math.floor(distance / 3600000);
        const minutes = Math.floor((distance % 3600000) / 60000);
        const seconds = Math.floor((distance % 60000) / 1000);

        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);
      }

      updateCountdown();
      setInterval(updateCountdown, 1000);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
